<template>
	<div class="position">
		<div>
			<h3 class="popup-tilte">Figyelmeztetés!</h3>
			<div class="fs-desc popup-content-width">
				Eltérő címen lévő melléképület esetén Minősített Fogyasztóbarát Otthonbiztosítás sajnos nem köthető,
				kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal:
			</div>
			<div class="text-center font-bold popup-content-width">
				<br />
				Telefon: +36 1 585 8888
				<br />
				Fax: +36 1 225 4090
				<br />
				E-mail: info@eurorisk.hu
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>
